<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-row dense>
          <v-col
            v-for="link in items"
            :key="link.id"
            cols="12"
            sm="6"
            md="4"
            class="d-flex align-items-stretch"
          >
            <v-card variant="flat" class="my-4 flex-grow-1 app-content-card">
              <v-card-text class="text-left">
                <h3>{{ $t("candidateTabs.links.title") }}</h3>
                <v-divider></v-divider>
                <p>
                  <strong>LinkedIn:</strong>
                  <a :href="link.LinkedIn" target="_blank">{{ link.LinkedIn }}</a>
                </p>
                <p>
                  <strong>Facebook:</strong>
                  <a :href="link.Facebook" target="_blank">{{ link.Facebook }}</a>
                </p>
                <p>
                  <strong>Instagram:</strong>
                  <a :href="link.Instagram" target="_blank">{{ link.Instagram }}</a>
                </p>
                <p>
                  <strong>GitHub:</strong>
                  <a :href="link.GitHub" target="_blank">{{ link.GitHub }}</a>
                </p>
              </v-card-text>
              <v-card-actions>
                <v-btn icon @click="openEditLinkDialog(link)">
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon color="error" @click="confirmDeleteLink(link.id)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-btn
          color="primary"
          @click="openAddLinkDialog"
          class="mb-4 d-flex align-items-stretch"
        >
          {{ $t("candidateTabs.links.addButton") }}
        </v-btn>
      </v-card-text>
    </v-card>

    <v-dialog v-model="addLinkDialog" max-width="600px">
      <v-card>
        <v-card-title>{{ $t("candidateTabs.links.addTitle") }}</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="addLink">
            <v-container>
              <v-row>
                <v-col cols="12"><v-text-field label="LinkedIn" v-model="newLink.LinkedIn" outlined></v-text-field></v-col>
                <v-col cols="12"><v-text-field label="Facebook" v-model="newLink.Facebook" outlined></v-text-field></v-col>
                <v-col cols="12"><v-text-field label="Instagram" v-model="newLink.Instagram" outlined></v-text-field></v-col>
                <v-col cols="12"><v-text-field label="GitHub" v-model="newLink.GitHub" outlined></v-text-field></v-col>
                <v-col cols="12">
                  <v-btn color="primary" type="submit">{{ $t("app.actions.add") }}</v-btn>
                  <v-btn variant="text" @click="closeAddLinkDialog">{{ $t("app.actions.cancel") }}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editLinkDialog" max-width="600px">
      <v-card>
        <v-card-title>{{ $t("candidateTabs.links.editTitle") }}</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="updateLink">
            <v-container>
              <v-row>
                <v-col cols="12"><v-text-field label="LinkedIn" v-model="editLink.LinkedIn" outlined></v-text-field></v-col>
                <v-col cols="12"><v-text-field label="Facebook" v-model="editLink.Facebook" outlined></v-text-field></v-col>
                <v-col cols="12"><v-text-field label="Instagram" v-model="editLink.Instagram" outlined></v-text-field></v-col>
                <v-col cols="12"><v-text-field label="GitHub" v-model="editLink.GitHub" outlined></v-text-field></v-col>
                <v-col cols="12">
                  <v-btn color="primary" type="submit">{{ $t("app.actions.save") }}</v-btn>
                  <v-btn variant="text" @click="closeEditLinkDialog">{{ $t("app.actions.cancel") }}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { defineComponent } from "vue";

// Links CRUD tab extracted from CandidateDetails.vue. Link fields are optional
// (no validation), matching the original behaviour. Platform names (LinkedIn,
// Facebook, Instagram, GitHub) are brand names and stay untranslated.
export default defineComponent({
  name: "CandidateLinksTab",
  props: {
    candidateId: { type: [String, Number], required: true },
    items: { type: Array, default: () => [] },
  },
  emits: ["refresh", "notify"],
  data() {
    return {
      addLinkDialog: false,
      newLink: { LinkedIn: "", Facebook: "", Instagram: "", GitHub: "" },
      editLinkDialog: false,
      editLink: { id: null, LinkedIn: "", Facebook: "", Instagram: "", GitHub: "" },
    };
  },
  methods: {
    openAddLinkDialog() {
      this.newLink = { LinkedIn: "", Facebook: "", Instagram: "", GitHub: "" };
      this.addLinkDialog = true;
    },
    closeAddLinkDialog() {
      this.addLinkDialog = false;
    },
    addLink() {
      const payload = {
        id_foreign: this.candidateId,
        LinkedIn: this.newLink.LinkedIn || null,
        Facebook: this.newLink.Facebook || null,
        Instagram: this.newLink.Instagram || null,
        GitHub: this.newLink.GitHub || null,
      };
      axios
        .post("/candidati/links", payload)
        .then(() => {
          this.$emit("notify", { message: this.$t("candidateTabs.links.added"), color: "success" });
          this.addLinkDialog = false;
          this.$emit("refresh");
        })
        .catch((error) => {
          console.error("Eroare la adăugarea link-urilor:", error);
          this.$emit("notify", { message: this.$t("candidateTabs.links.addError"), color: "error" });
        });
    },
    openEditLinkDialog(link) {
      this.editLink = { ...link };
      this.editLinkDialog = true;
    },
    closeEditLinkDialog() {
      this.editLinkDialog = false;
    },
    updateLink() {
      const linkId = this.editLink.id;
      const payload = {
        id_foreign: this.candidateId,
        LinkedIn: this.editLink.LinkedIn || null,
        Facebook: this.editLink.Facebook || null,
        Instagram: this.editLink.Instagram || null,
        GitHub: this.editLink.GitHub || null,
      };
      axios
        .put(`/candidati/links/${linkId}`, payload)
        .then(() => {
          this.$emit("notify", { message: this.$t("candidateTabs.links.updated"), color: "success" });
          this.editLinkDialog = false;
          this.$emit("refresh");
        })
        .catch((error) => {
          console.error("Eroare la actualizarea link-urilor:", error);
          this.$emit("notify", { message: this.$t("candidateTabs.links.updateError"), color: "error" });
        });
    },
    confirmDeleteLink(id) {
      if (confirm(this.$t("candidateTabs.links.deleteConfirm"))) {
        this.deleteLink(id);
      }
    },
    deleteLink(id) {
      axios
        .delete(`/candidati/links/${id}`)
        .then(() => {
          this.$emit("notify", { message: this.$t("candidateTabs.links.deleted"), color: "success" });
          this.$emit("refresh");
        })
        .catch((error) => {
          console.error("Eroare la ștergerea link-urilor:", error);
          this.$emit("notify", { message: this.$t("candidateTabs.links.deleteError"), color: "error" });
        });
    },
  },
});
</script>
